import React, { Component,useState,useEffect } from 'react'
import ReactMarkdown from 'react-markdown'
import { makeStyles, Typography } from "@material-ui/core";
import './../srcv/src/main/javascript/github-files.js';
import Divider from '@material-ui/core/Divider';
import $ from 'jquery'
import './../App.css'
const useStyles = makeStyles({
    gridContainer: {
      paddingLeft: "100px",
      paddingRight: "100px",
      paddingTop : "20px",
      marginBottom : "20px",
      color : 'white'
    },
    button : {
        paddingLeft: "50px",
        paddingRight: "50px"   
    },
    myProjectTitle : {
        paddingLeft : "100px",
        paddingBottom : "10px",
        color : '#c92828'
        
    },
    divider :{
        paddingBottom : "2px",
        marginLeft : "100px",
        width : "300px",
        background : '#379683'
    }
  });

function About(props){
    // const [loading,setLoading] = useState(true);
    // const [userData, setUserData] = useState({});
    const classes = useStyles();
    // const token = "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";
    // useEffect(() => {
    //     getGitHubUserWithFetch();
    // }, []);

    // const getGitHubUserWithFetch = async () => {
    //     const response = await fetch(
    //         "https://api.github.com/repos/parmaraakash7/parmaraakash7/readme",
    //         {
    //             headers: {
    //               authorization: `${token}`,
    //               Accept: "application/vnd.github.v3.html"
    //             }
    //         }
    //     );
    //     if(response.status == 404){
    //         console.log('hi');
    //         setLoading(false);
    //         const jsonData = await response.json();
    //         setUserData(jsonData.message);
    //     }
    //     else{
    //         const t = (await response.text()).valueOf();
    //         setUserData(t);
    //         setLoading(false);
    //     }    
    // };

    function createMarkup() { 
        return {__html: props.htmlData}; 
    };

    // if(loading){
    //     return (
    //         <div>Loading....</div>
    //     )
        
    // }
    // else{
    //     return (
    //         <>
    //         <Typography variant="h3" className={classes.myProjectTitle}>
    //             About Me
    //         </Typography>
    //         <Divider variant="inset" className={classes.divider} />
    //         <div dangerouslySetInnerHTML={createMarkup()} className={classes.gridContainer}/>   
    //         </>
    //     )
    // }
    return (
        <>
        <Typography variant="h3" className={classes.myProjectTitle}>
            About Me
        </Typography>
        <Divider className={classes.divider} light="true" />
        <div dangerouslySetInnerHTML={createMarkup()} className={classes.gridContainer}/>   
        </>
    )
}

export default About
